// Client-side capability gate (UI hiding only — the server re-checks every write, invariant #3).
import type { ReactNode } from "react";
import { can, type Action, type RbacContext, type RbacUser } from "@rrid/shared-types";
import { useAuth } from "../lib/auth.js";

export function useCan(): (action: Action, ctx?: RbacContext) => boolean {
  const { user } = useAuth();
  return (action, ctx) => {
    if (!user) return false;
    const rbacUser: RbacUser = { email: user.email, roles: user.roles, domains: user.domains };
    return can(rbacUser, action, ctx);
  };
}

export function Can({
  action,
  ctx,
  children,
  fallback = null,
}: {
  action: Action;
  ctx?: RbacContext;
  children: ReactNode;
  fallback?: ReactNode;
}): JSX.Element {
  const allowed = useCan()(action, ctx);
  return <>{allowed ? children : fallback}</>;
}
